import { NgModule } from '@angular/core';
import { TablePaginatorComponent } from './components/table-paginator/table-paginator.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CnpjValidatorDirective } from './validators/cnpj-validator.directive';
import { SelectIdValidatorDirective } from './validators/select-id-validator.directive copy';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { NumberValidatorDirective } from './validators/number-validator.directive';
import { LoadingComponent } from './components/loading/loading.component';
import { DialogDefaultComponent } from './components/dialog-default/dialog-default.component';
import { CommonModule, DatePipe } from '@angular/common';
import { HoraMinutoValidatorDirective } from './validators/hora-minuto-validator.directive';
import { DataUtcPipe } from './pipes/data-utc.pipe';
import { ProcessoHistoricoComponent } from './components/processo-historico/processo-historico.component';
import { FiltroComponent } from './components/filtro/filtro.component';
import { ModalQuestaoSimplesComponent } from './components/modals/modal-questao-simples/modal-questao-simples.component';
import { ModalQuestaoTextoComponent } from './components/modals/modal-questao-texto/modal-questao-texto.component';
import { ModalSetoresProducaoComponent } from './components/modals/modal-setores-producao/modal-setores-producao.component';
import { ModalCadastroFornecedorComponent } from './components/modals/modal-cadastro-fornecedor/modal-cadastro-fornecedor.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { DocumentoPendenteItemComponent } from './components/documento-pendente-item/documento-pendente-item.component';
import { ModalDesenhoComponent } from './components/modals/modal-desenho/modal-desenho.component';
import { DesenhosProdutoComponent } from './components/desenhos-produto/desenhos-produto.component';
import { EspecificacaoClienteDestaqueComponent } from './components/especificacao-cliente-destaque/especificacao-cliente-destaque.component';

@NgModule({
  declarations: [
    TablePaginatorComponent,
    CnpjValidatorDirective,
    SelectIdValidatorDirective,
    NumberValidatorDirective,
    LoadingComponent,
    DialogDefaultComponent,
    HoraMinutoValidatorDirective,
    FiltroComponent,
    ModalQuestaoSimplesComponent,
    ModalQuestaoTextoComponent,
    ModalSetoresProducaoComponent,
    ModalCadastroFornecedorComponent,
    DocumentoPendenteItemComponent,
    ModalDesenhoComponent,
    DataUtcPipe,
    ProcessoHistoricoComponent,
    DesenhosProdutoComponent,
    EspecificacaoClienteDestaqueComponent
  ],
  exports: [
    TablePaginatorComponent,
    ReactiveFormsModule,
    FormsModule,
    CnpjValidatorDirective,
    SelectIdValidatorDirective,
    NumberValidatorDirective,
    NgxMaskDirective,
    LoadingComponent,
    DialogDefaultComponent,
    HoraMinutoValidatorDirective,
    FiltroComponent,
    ModalQuestaoSimplesComponent,
    ModalQuestaoTextoComponent,
    ModalSetoresProducaoComponent,
    ModalCadastroFornecedorComponent,
    DragDropModule,
    DocumentoPendenteItemComponent,
    DataUtcPipe,
    ProcessoHistoricoComponent,
    ModalDesenhoComponent,
    DesenhosProdutoComponent,
    EspecificacaoClienteDestaqueComponent
  ],
  imports: [
    ReactiveFormsModule,
    FormsModule,
    NgxMaskDirective,
    CommonModule,
    DragDropModule
  ],
  providers: [
    provideNgxMask(),
    // O DataUtcPipe delega a formatação ao DatePipe, então precisa dele
    // injetável. O DatePipe não é provider por padrão nem vem do CommonModule.
    DatePipe
  ]

})
export class SharedModule { }
